/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'ngf-message-info,ngf-message-success,ngf-message-fail,ngf-message-warning',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIcon
  ]
})
export class MessageComponent {

  @Input()
  showIcon = true;
  @Input()
  showClose = false;

  // TODO: we should refactor this output name, bc it's name overlap with native event
  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  close = new EventEmitter<void>();
}
